import type { AccessPair } from '@/shared/lib'

/**
 * Пара прав заказного каталога РБ `/v1/catalog/order-rb/**` — зеркало `@ActingAs` бэка: клиент
 * смотрит свой заказной каталог (`own`), менеджер — только глазами клиента (`onBehalf`), без
 * модификатора ручка отвечает `400 CLIENT_REQUIRED`. Полного вида менеджера нет: `full` не задан,
 * поэтому менеджер без клиента — режим `needs-client` (страница сама предлагает выбрать клиента),
 * а в меню раздел ему не показывается. `accepts` — те же параметры модификатора, что у каталога.
 */
export const ORDER_CATALOG_ACCESS: AccessPair = {
  own: 'catalog.order.view',
  onBehalf: 'catalog.view-as-client',
  accepts: ['account', 'unp', 'settlement', 'cart'],
}
